import React from "react";

import { IcoUser, IcoArrowRight } from "assets/icons";
import { ActionButton } from "components";
import { TravelCardProps } from "./types";

import styles from "./styles.module.scss";

export default function TravelCard({
	departure,
	arrival,
	departureDate,
	arrivalDate,
	passengers,
	onClick
}: TravelCardProps) {
	return (
		<div className={styles.container} onClick={onClick}>
			<div className={styles.cardContent}>
				<div className={styles.travelTitle}>
					<span>
						{departure}/{arrival}
					</span>
				</div>
				<div className={styles.travelInfo}>
					<span>
						{departureDate} a {arrivalDate}
					</span>
					<div className={styles.passengerInfo}>
						<IcoUser width="12" height="14" />
						<span>{passengers} passageiros</span>
					</div>
				</div>
			</div>
			<IcoArrowRight />
		</div>
	);
}
